import { useRef, useState, useEffect } from 'react';
export const useOpenedSubMenuIds = () => {
    const refOpenedSubMenuIds = useRef([]);
    const onOpenSubMenu = (e) => {
        const { id } = e;
        // istanbul ignore else
        if (!refOpenedSubMenuIds.current.includes(id)) {
            refOpenedSubMenuIds.current.push(id);
        }
    };
    const onCloseSubMenu = (e) => {
        const { id } = e;
        if (refOpenedSubMenuIds.current.includes(id)) {
            refOpenedSubMenuIds.current.splice(refOpenedSubMenuIds.current.indexOf(id), 1);
        }
    };
    return { refOpenedSubMenuIds, onOpenSubMenu, onCloseSubMenu };
};
function getElementLeft(element) {
    let actualLeft = element.offsetLeft;
    let current = element.offsetParent;
    while (current !== null) {
        actualLeft += current.offsetLeft;
        current = current.offsetParent;
    }
    return actualLeft;
}
function getElementTop(element) {
    let actualTop = element.offsetTop;
    let current = element.offsetParent;
    while (current !== null) {
        actualTop += current.offsetTop;
        current = current.offsetParent;
    }
    return actualTop;
}
export const useAnchorElem = () => {
    const anchorRef = useRef(null);
    const refDynamicAnchorElem = useRef(null);
    const [anchorElem, setAnchorElem] = useState(null);
    useEffect(() => {
        setAnchorElem(anchorRef.current);
    }, []);
    const resetDynamicAnchorElem = (e) => {
        let dynamicAnchorElem = refDynamicAnchorElem.current;
        if (!dynamicAnchorElem) {
            dynamicAnchorElem = document.createElement('div');
            document.body.appendChild(dynamicAnchorElem);
            refDynamicAnchorElem.current = dynamicAnchorElem;
        }
        let pageX = 0;
        let pageY = 0;
        if (e) {
            pageX = e.pageX;
            pageY = e.pageY;
        }
        else {
            const rect = anchorRef.current.getBoundingClientRect();
            const elemLeft = getElementLeft(anchorRef.current);
            const elemTop = getElementTop(anchorRef.current);
            pageX = elemLeft + rect.width / 2;
            pageY = elemTop + rect.height / 2;
        }
        const pointerWidth = 0;
        const pointerHeight = 0;
        dynamicAnchorElem.removeAttribute('style');
        dynamicAnchorElem.style.position = 'absolute';
        dynamicAnchorElem.style.width = `${pointerWidth}px`;
        dynamicAnchorElem.style.height = `${pointerHeight}px`;
        dynamicAnchorElem.style.left = `${pageX}px`;
        dynamicAnchorElem.style.top = `${pageY}px`;
        dynamicAnchorElem.style.bottom = `auto`;
        dynamicAnchorElem.style.right = `auto`;
        setAnchorElem({
            getBoundingClientRect: () => dynamicAnchorElem.getBoundingClientRect(),
        });
    };
    return {
        anchorRef,
        anchorElem,
        resetDynamicAnchorElem,
    };
};
